import { Box, Switch, TextField, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const TimePickerTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, settings, setSettings }) => {
  const timeFormat = settings?.timeFormat || "12hr";

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Time Format</Typography>
        <ToggleButtonGroup value={timeFormat} exclusive size="small" fullWidth
          onChange={(_, v) => v && setSettings({ ...settings, timeFormat: v })}
          sx={{ "& .MuiToggleButton-root": { textTransform: "none", fontSize: 12, fontWeight: 600, flex: 1 } }}>
          <ToggleButton value="12hr">12 Hour</ToggleButton>
          <ToggleButton value="24hr">24 Hour</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Time Range</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField fullWidth label="Min Time" type="time" size="small" InputLabelProps={{ shrink: true }}
            value={settings?.minTime || ""} onChange={(e) => setSettings({ ...settings, minTime: e.target.value })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
          <TextField fullWidth label="Max Time" type="time" size="small" InputLabelProps={{ shrink: true }}
            value={settings?.maxTime || ""} onChange={(e) => setSettings({ ...settings, maxTime: e.target.value })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please select a valid time" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default TimePickerTab;
